import React from 'react';
import * as Icons from 'react-icons/fi';
import { SideMenu, MenuItem, MenuOverlay } from '../../../styles/AdminLayout.styles';

interface AdminSidebarProps {
    isOpen: boolean;
    activeSection: string;
    onSectionChange: (section: string) => void;
    onClose: () => void;
}

interface MenuItemConfig {
    id: string;
    icon: keyof typeof Icons;
    label: string;
}

const menuItems: MenuItemConfig[] = [
    { id: 'videos', icon: 'FiVideo', label: 'Vídeos' },
    { id: 'social', icon: 'FiShare2', label: 'Redes Sociales' },
    { id: 'contact', icon: 'FiPhone', label: 'Contacto' },
    { id: 'legal', icon: 'FiFileText', label: 'Páginas Legales' },
    { id: 'app-download', icon: 'FiSmartphone', label: 'Descargar App' },
    { id: 'password', icon: 'FiLock', label: 'Cambiar Contraseña' }
];

const AdminSidebar: React.FC<AdminSidebarProps> = ({ isOpen, activeSection, onSectionChange, onClose }) => {
    const handleItemClick = (sectionId: string) => {
        onSectionChange(sectionId);
        onClose();
    };

    return (
        <>
            <MenuOverlay $open={isOpen} onClick={onClose} />

            <SideMenu $open={isOpen}>
                {menuItems.map((item) => {
                    const IconComponent = Icons[item.icon];
                    return (
                        <MenuItem
                            key={item.id}
                            $active={activeSection === item.id}
                            onClick={() => handleItemClick(item.id)}
                        >
                            {React.createElement(IconComponent as any, { size: 20 })}
                            {item.label}
                        </MenuItem>
                    );
                })}
            </SideMenu>
        </>
    );
};

export default AdminSidebar;
